.filters {
	width: 100%;
	display: flex;
	height: fit-content;

	align-items: center;
	flex-direction: column;
	padding-bottom: 20px;
	border-bottom: 2px solid var(--depth1);
}
.filters > h1 {
	font-size: 2.5rem;
	font-weight: bold;
	margin: 0;
	padding: 0;
}
.filterList {
	display: flex;

	justify-content: flex-end;
}
